import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LegalNoticeRoutingModule} from "./legal-notice-routing.module";

import {ComponentsModule} from "../shared/components/components.module";
import {RouterModule} from "@angular/router";
import {PipesModule} from "../shared/pipes/pipes.module";
import {LegalNoticeComponent} from "./legal-notice.component";
import { PrivacyComponent } from './privacy/privacy.component';


@NgModule({
  declarations: [
    LegalNoticeComponent,
    PrivacyComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    ComponentsModule,
    LegalNoticeRoutingModule,
  ]
})
export class LegalNoticeModule {
}
